import { getTemperature } from '../../../../helper/temperature';

export function P0003607TemperatureHivernage() {
  let r = [];

  for (let i = 10; i <= 20; i++) {
    r.push({
      ref: i,
      label: getTemperature(i, 0),
    });
  }

  return r;
}
